/* eslint-disable @typescript-eslint/no-namespace */
/*
    This code was automatically generated, and then edited by hand.
*/
import { makeBooleanDataField, makeInt64DataField, makeStringDataField } from '../DataFieldHelper';
export var Result;
(function (Result) {
    var contractName = 'Office.System.Result';
    /* Gets data fields for the Office.System.Result contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        dataFields.push(makeInt64DataField("".concat(instanceName, ".Code"), contract.code));
        if (contract.type !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Type"), contract.type));
        }
        if (contract.tag !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".Tag"), contract.tag));
        }
        if (contract.isExpected !== undefined) {
            dataFields.push(makeBooleanDataField("".concat(instanceName, ".IsExpected"), contract.isExpected));
        }
        dataFields.push(makeStringDataField('zC.Activity.Result', contractName));
        return dataFields;
    }
    Result.getFields = getFields;
})(Result || (Result = {})); // Result
export var Activity;
(function (Activity) {
    Activity.contractName = 'Office.System.Activity';
    /* Gets data fields for the Office.System.Activity contract */
    function getFields(contract) {
        var instanceName = 'Activity';
        var dataFields = [];
        if (contract.cV !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".CV"), contract.cV));
        }
        dataFields.push(makeInt64DataField("".concat(instanceName, ".Duration"), contract.duration));
        dataFields.push(makeInt64DataField("".concat(instanceName, ".Count"), contract.count));
        dataFields.push(makeInt64DataField("".concat(instanceName, ".AggMode"), contract.aggMode));
        if (contract.success !== undefined) {
            dataFields.push(makeBooleanDataField("".concat(instanceName, ".Success"), contract.success));
        }
        if (contract.result !== undefined) {
            dataFields.push.apply(dataFields, Result.getFields("".concat(instanceName, ".Result"), contract.result));
        }
        dataFields.push(makeStringDataField('zC.Activity', Activity.contractName));
        return dataFields;
    }
    Activity.getFields = getFields;
})(Activity || (Activity = {})); // Activity
export var Host;
(function (Host) {
    /**
     * Gets data fields for the Office.System.Host contract
     * @deprecated - Do not use the Office.System.Host contract
     */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.id !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Id"), contract.id));
        }
        if (contract.version !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Version"), contract.version));
        }
        if (contract.sessionId !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".SessionId"), contract.sessionId));
        }
        return dataFields;
    }
    Host.getFields = getFields;
})(Host || (Host = {})); // Host
export var User;
(function (User) {
    /* Gets data fields for the Office.System.User contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.alias !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Alias"), contract.alias));
        }
        if (contract.primaryIdentityHash !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".PrimaryIdentityHash"), contract.primaryIdentityHash));
        }
        if (contract.primaryIdentitySpace !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".PrimaryIdentitySpace"), contract.primaryIdentitySpace));
        }
        if (contract.tenantId !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".TenantId"), contract.tenantId));
        }
        if (contract.tenantGroup !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".TenantGroup"), contract.tenantGroup));
        }
        if (contract.isAnonymous !== undefined) {
            dataFields.push(makeBooleanDataField("".concat(instanceName, ".IsAnonymous"), contract.isAnonymous));
        }
        return dataFields;
    }
    User.getFields = getFields;
})(User || (User = {})); // User
export var Funnel;
(function (Funnel) {
    /* Gets data fields for the Office.System.Funnel contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.name !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Name"), contract.name));
        }
        if (contract.state !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".State"), contract.state));
        }
        return dataFields;
    }
    Funnel.getFields = getFields;
})(Funnel || (Funnel = {})); // Funnel
export var UserAction;
(function (UserAction) {
    /* Gets data fields for the Office.System.UserAction contract */
    function getFields(instanceName, contract) {
        var dataFields = [];
        if (contract.id !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".Id"), contract.id));
        }
        if (contract.name !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".Name"), contract.name));
        }
        if (contract.commandSurface !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".CommandSurface"), contract.commandSurface));
        }
        if (contract.parentName !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".ParentName"), contract.parentName));
        }
        if (contract.triggerMethod !== undefined) {
            dataFields.push(makeStringDataField("".concat(instanceName, ".TriggerMethod"), contract.triggerMethod));
        }
        if (contract.timeOffsetMs !== undefined) {
            dataFields.push(makeInt64DataField("".concat(instanceName, ".TimeOffsetMs"), contract.timeOffsetMs));
        }
        return dataFields;
    }
    UserAction.getFields = getFields;
})(UserAction || (UserAction = {})); // UserAction
//# sourceMappingURL=officeeventschema.tml.js.map